import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import Backdrop from "Components/Common/Backdrop";

import ViewOtherApplicationModal from "./ViewOtherApplicationModal";

import { useGetOtherApplicationDetailQuery } from "apis/otherApplicationDetails";

const OtherApplicationViewModal = ({
  viewApplicationQuery,
  applicationType,
  handleClose,
  t,
}) => {
  const {
    data: {
      data: { applicationType: { id: applicationTypeId } = {} } = {},
    } = {},
    isLoading,
    isFetching,
  } = useGetOtherApplicationDetailQuery(viewApplicationQuery);

  if (isLoading || isFetching) {
    return <Backdrop open />;
  }

  return (
    <>
      {!!applicationTypeId && !!viewApplicationQuery && (
        <ViewOtherApplicationModal
          isOpen={!!viewApplicationQuery}
          handleClose={handleClose}
          viewApplicationQuery={viewApplicationQuery}
          title={t(`${applicationType} Details`)}
        />
      )}
    </>
  );
};

OtherApplicationViewModal.propTypes = {
  viewApplicationQuery: PropTypes.object,
  applicationType: PropTypes.string,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(OtherApplicationViewModal);
